module.exports = "/src/views/games/other/images/roles/doctor.png";